import React, { useEffect, useLayoutEffect, useRef } from "react";
import landingvid from "./assets/landing.mp4";

const Landing = ({ onComplete }) => {
    const videoRef = useRef(null);

    // Runs synchronously before paint — ensures the muted/playsinline
    // ATTRIBUTES (not just JS properties) exist before iOS evaluates autoplay
    useLayoutEffect(() => {
        const video = videoRef.current;
        if (video) {
            video.defaultMuted = true;
            video.muted = true;
            video.setAttribute("muted", "");
            video.setAttribute("playsinline", "");
            video.setAttribute("webkit-playsinline", "");
        }
    }, []);

    useEffect(() => {
        const originalBodyOverflow = document.body.style.overflow;
        const originalHtmlOverflow = document.documentElement.style.overflow;

        document.body.style.overflow = "hidden";
        document.documentElement.style.overflow = "hidden";

        const preventScroll = (e) => e.preventDefault();
        window.addEventListener("wheel", preventScroll, { passive: false });
        window.addEventListener("touchmove", preventScroll, { passive: false });

        const tryPlay = () => {
            const video = videoRef.current;
            if (!video) return;
            video.muted = true;
            video.play().catch((err) => {
                console.error("Autoplay prevented by browser:", err);
            });
        };

        tryPlay();

        // Fallback: if iOS still blocked it (e.g. Low Power Mode), start on first touch
        const retryOnGesture = () => {
            tryPlay();
            window.removeEventListener("touchstart", retryOnGesture);
        };
        window.addEventListener("touchstart", retryOnGesture, { once: true });

        return () => {
            document.body.style.overflow = originalBodyOverflow;
            document.documentElement.style.overflow = originalHtmlOverflow;
            window.removeEventListener("wheel", preventScroll);
            window.removeEventListener("touchmove", preventScroll);
            window.removeEventListener("touchstart", retryOnGesture);
        };
    }, []);

    return (
        <div
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                backgroundColor: "black",
                zIndex: 9999,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                touchAction: "none",
                overflow: "hidden",
            }}
        >
            <video
                ref={videoRef}
                src={landingvid}
                autoPlay
                defaultMuted
                muted
                playsInline
                webkit-playsinline="true"
                preload="auto"
                onEnded={onComplete}
                style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    pointerEvents: "none",
                    userSelect: "none",
                    WebkitUserSelect: "none",
                }}
            />
        </div>
    );
};

export default Landing;
